module.exports = {
      id: "app-exclusive-usage",
      viewBox: "0 0 26.66 26.063",
      url: "/" + "sprite-84df178c245af8be09420a4d0455d997.svg#app-exclusive",
      toString: function () {
        return this.url;
      }
    }